import { push, goBack, replace } from 'connected-react-router';
import { dispatch } from '../../store';

export function navPath(pathname : string) {
    dispatch(push(pathname));
}

export function navBack() {
    dispatch(goBack());
}

export function navUrl(url : string, state : Record<string, unknown> = {}) {
    dispatch(replace({
        pathname: url,
        state,
    }));
}
